import { useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../../../../../common/CmnContext';
import { LiveReserveContext } from '../../../../LiveLessonReseveContext';


function LiveReserveSelectInstructorModalItem(props: any) {

  const isPc = useContext(cmnContext).isPc;
  const {
    instId, setInstId,
  } = useContext(LiveReserveContext);

  const inst = props.inst;
  const setIsDispModal = props.setIsDispModal;
  const listWidth = props.listWidth;
  // 講師情報から画像取得
  const getInstImg = props.getInstImg;
  // 講師の趣味・スコア情報
  const getInstDetailInfo = props.getInstDetailInfo;

  const imgSize = isPc? listWidth/7 : listWidth/4;

  const [imgSrc, setImgSrc] = useState<string>('');
  const [dispInfo, setDispInfo] = useState<string>('');

  const [isSelected, setIsSelected] = useState<boolean>(false);


  useEffect(() => {
    if(inst) {
      // 画像
      const newImgSrc = getInstImg(inst);
      setImgSrc(newImgSrc);

      // 講師情報
      const newDispInfo = getInstDetailInfo(inst);
      setDispInfo(newDispInfo);
    }
  }, [inst])


  useEffect(() => {
    setIsSelected(instId == inst.inst_id);
  }, [instId, inst])

  const onClickInst = () => {
    setInstId(inst.inst_id);
    setIsDispModal(false);
  }


  return (
    <div
      key={inst.inst_id}
      style={{
        display: 'flex',
        textAlign: 'left',
        alignItems: 'center',
        padding: isPc? '15px 2%' : '10px 3%',
      }}
    >

      {imgSrc &&
        <img
          className="img-rounded img-responsive"
          style={{
            width: imgSize,
            height: imgSize,
            objectFit: 'cover',
            marginRight: '10px',
          }}
          src={imgSrc}
        />
      }

      <div style={{flex: 1}}>
        <p style={{margin: 0, fontWeight: 'bold'}}>{inst.name} 講師</p>
        <p style={{margin: 0, color: 'red', fontWeight: 'bold'}}>残り{inst.schedule_count}枠</p>

        {dispInfo &&
          <p style={{
              margin: 0,
              fontSize: '12px',
              display: '-webkit-box',
              WebkitLineClamp: 2, // 2行まで
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
          }}>{dispInfo}</p>
        }

        <button
          type="button"
          className={isSelected? 'btn btn-warning' : 'btn btn-success'}
          style={{
            alignSelf: 'center',
            width: '100%',
            padding: '5px 10px',
            marginTop: '5px',
          }}
          onClick={onClickInst}
          disabled={isSelected}
        >
          {isSelected? '選択中' : '選択' }
        </button>
      </div>

    </div>
  );
}
  
export default LiveReserveSelectInstructorModalItem;